<script lang="ts" setup>
  import SettingsCogPath from '../SettingsCogPath.vue';
  import Countdown from './Countdown.vue';

  defineProps<{ secondsLeft: string }>();
  defineEmits<{ click: [] }>();
</script>

<template>
  <button :aria-label="`Host menu ${secondsLeft}`" class="host-countdown" type="button" @click="$emit('click')">
    <svg
      aria-hidden="true"
      class="cog"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.25"
      viewBox="0 0 24 24"
    >
      <SettingsCogPath />
    </svg>
    <Countdown class="seconds" :seconds-left="secondsLeft" />
  </button>
</template>

<style scoped>
  .host-countdown {
    background: transparent;
    border: none;
    border-radius: var(--radius-full);
    color: inherit;
    cursor: pointer;
    display: grid;
    font: inherit;
    height: 3.25rem;
    padding: 0;
    place-items: center;
    width: 3.25rem;

    &:focus-visible {
      outline: 2px solid var(--color-primary);
      outline-offset: 2px;
    }

    &:active {
      transform: scale(0.92);
    }
  }

  .cog {
    color: color-mix(in srgb, var(--color-primary), transparent 60%);
    grid-area: 1 / 1;
    height: 100%;
    width: 100%;
  }

  .seconds {
    grid-area: 1 / 1;
    text-align: center;
  }
</style>
